<script>
    import { checkbox } from 'vue-strap';
    import radio from '~componentes/Radio.vue';

    export default {
        components: { checkbox, radio },
        props: {
            itemSolicitacao: {
                required: true,
                type: Object,
            },
            manterObservacao: {
                default: true,
                type: Boolean,
            },
            desabilitarExecutora: {
                default: false,
                type: Boolean,
            },
            produtos: {
                required: true
            },
            tiposProdutos: {
                required: true
            },
            indice: {
              required: true
            }
        },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
            }
        },
        computed: {
            observacaoItemCompraContador() {
                let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ?
                    this.itemSolicitacao.observacaoItemCompra.length : 0;

                return 500 - quantidadeCaracteres;
            },
        },
        methods: {
            validar() {
                return this.$validator.validateAll();
            },
            validarCustomizado() {
                var validou = true;

                if (!this.itemSolicitacao.executora) {
                    validou = null;
                }

                if (this.itemSolicitacao.executora === '1') {
                    this.removeErroExecutora();

                    if (!this.itemSolicitacao.projetoAceitarRetirarMercadoria) {
                        if (!this.errors.has('projetoAceitarRetirarMercadoria')) {
                            this.errors.items.push(
                                { "id": "_y980569951285l9f3565sdas", "field": "projetoAceitarRetirarMercadoria", "msg": "Selecione se o projeto aceita retirar mercadoria.", "rule": "required", "scope": null }
                            )

                            validou = null;
                        }
                        else validou = null;
                    }

                    if (!this.itemSolicitacao.projetoAceitarVariacaoPreco) {
                        if (!this.errors.has('projetoAceitarVariacaoPreco')) {
                            this.errors.items.push(
                                { "id": "_y980569951285l9f3565sda", "field": "projetoAceitarVariacaoPreco", "msg": "Selecione se o projeto aceita variação de preço.", "rule": "required", "scope": null }
                            )

                            validou = null;
                        }
                        else validou = null;
                    }

                    if (!this.itemSolicitacao.projetoAceitarFrete) {
                        if (!this.errors.has('projetoAceitarFrete')) {
                            this.errors.items.push(
                                { "id": "_y980569951285l9f3565sd", "field": "projetoAceitarFrete", "msg": "Selecione se o projeto aceita frete.", "rule": "required", "scope": null }
                            )

                            validou = null;
                        }
                        else validou = null;
                    }
                }

                if (this.itemSolicitacao.executora === '2') {
                    this.removeErroExecutora();
                }

                return this.$validator
                    .validate('executora', validou)
            },
            removeErro(field) {
                var pos = -1;

                while (this.errors.has(field)) {
                    for (var i = 0; i < this.errors.items.length; i++) {
                        if (this.errors.items[i].field == field) {
                            pos = i
                            break
                        }
                    }

                    if (pos > -1) {
                        this.errors.items.splice(pos, 1)
                    }
                }
            },
            removeErroExecutora() {
                this.removeErro('executora');
            },
            removeErroProjetoAceitarRetirarMercadoria() {
                this.removeErro('projetoAceitarRetirarMercadoria');

                if (this.indice == -1)
                  this.itemSolicitacao.observacaoItemCompra = '';
            },
            removeErroProjetoAceitarVariacaoPreco() {
                this.removeErro('projetoAceitarVariacaoPreco');

                if (this.indice == -1)
                  this.itemSolicitacao.percentualVariacaoValor = '';
            },
            removeErroProjetoAceitarFrete() {
                this.removeErro('projetoAceitarFrete');

                if (this.indice == -1)
                  this.itemSolicitacao.percentualVariacaoFrete = '';
            }
        },
        updated() {
          const _this = this;

          this.$watch('itemSolicitacao.projetoAceitarVariacaoPreco', function () {
            _this.removeErroProjetoAceitarVariacaoPreco();
          })

          this.$watch('itemSolicitacao.projetoAceitarFrete', function () {
            _this.removeErroProjetoAceitarFrete();
          })

          this.$watch('itemSolicitacao.projetoAceitarRetirarMercadoria', function () {
            _this.removeErroProjetoAceitarRetirarMercadoria();
          })
        },
        watch: {
            'itemSolicitacao.executora': 'removeErroExecutora',
        }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label">Observação:</label>

                    <p>Compras Online são permitidas apenas para empresas que emitem faturas para Pessoas Jurídicas.</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('executora') && itemSolicitacao.executora == ''}">
                    <label class="control-label" for="executora">Executora</label><br />

                    <radio v-model="itemSolicitacao.executora"
                           id="executora1"
                           name="executora"
                           selected-value="1"
                           type="success"
                           :inline="true"
                           class="margin-right-10"
                           :disabled="desabilitarExecutora"
                           data-vv-name="executora"
                           v-validate="'required'">
                        FUSP
                    </radio>

                    <radio v-model="itemSolicitacao.executora"
                           id="executora2"
                           name="executora"
                           selected-value="2"
                           type="success"
                           :disabled="desabilitarExecutora"
                           :inline="true">
                        Projeto
                    </radio>


                    <p class="text-danger" v-show="errors.has('executora') && itemSolicitacao.executora == ''">{{ errors.first('executora') }}</p>
                </div>
            </div>
        </div>

        <div v-if="itemSolicitacao.executora">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                        <label class="control-label" for="tipoProduto">Tipo de produto</label>

                        <select class="form-control"
                                id="tipoProduto"
                                v-model="itemSolicitacao.idTipoProduto"
                                data-vv-name="tipoProduto"
                                data-vv-as="tipo de produto"
                                v-validate="'required'">
                            <option value="">Selecione...</option>
                            <option :value="tipoProduto.idTipoProduto"
                                    v-for="tipoProduto in tiposProdutos">
                                {{ tipoProduto.nomeTipoProduto }}
                            </option>
                        </select>

                        <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                        <label class="control-label" for="produto">Produto</label>

                        <select class="form-control"
                                id="produto"
                                v-model="itemSolicitacao.idProduto"
                                data-vv-name="produto"
                                data-vv-as="produto"
                                v-validate="'required'">
                            <option value="">Selecione...</option>
                            <option :value="produto.idProduto"
                                    v-for="produto in produtos">
                                {{ produto.nome }}
                            </option>
                        </select>

                        <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                        <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

                        <textarea class="form-control"
                                  id="descricao-material"
                                  v-model="itemSolicitacao.descricao"
                                  v-validate="'required'"
                                  data-vv-name="descricaoMaterial"
                                  data-vv-as="descrição do material/serviço">
                    </textarea>

                        <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                    <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                        <label class="control-label" for="quantidade">Quantidade</label>

                        <input type="text"
                               class="form-control text-right"
                               id="quantidade"
                               v-model="itemSolicitacao.quantidade"
                               data-vv-name="quantidade"
                               v-validate="'required|not_zero'"
                               v-mascara="'moeda'">

                        <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                    </div>
                </div>
                <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                    <div class="form-group">
                        <label class="control-label" for="unidade">Unidade</label>

                        <input type="text"
                               class="form-control"
                               id="unidade"
                               v-model="itemSolicitacao.unidade"
                               maxlength="3">
                    </div>
                </div>
                <div class="col-xs-4" v-if="configuracao.utilizarValorEstimado">
                    <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                        <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                        <input type="text"
                               class="form-control text-right"
                               id="valor-estimado"
                               v-model="itemSolicitacao.valorEstimado"
                               data-vv-name="valorEstimado"
                               v-validate="'required|not_zero'"
                               data-vv-as="valor estimado"
                               v-mascara="'moeda'">

                        <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-3" v-if="itemSolicitacao.executora == '2'">
                    <div class="form-group required" :class="{'has-error': errors.has('empresaProduto')}">
                        <label class="control-label" for="empresaProduto">Empresa do site</label>

                        <input type="text"
                               class="form-control"
                               id="empresaProduto"
                               data-vv-name="empresaProduto"
                               v-validate="'required'"
                               data-vv-as="empresa do site"
                               v-model="itemSolicitacao.empresaProduto">

                        <p class="text-danger" v-show="errors.has('empresaProduto')">{{ errors.first('empresaProduto') }}</p>
                    </div>
                </div>

                <div :class="[itemSolicitacao.executora == '2' ? 'col-xs-9' : 'col-xs-12']">
                    <div class="form-group required" :class="{'has-error': errors.has('link')}">
                        <label class="control-label" for="link">Link do produto</label>

                        <input type="text"
                               class="form-control"
                               id="link"
                               data-vv-name="link"
                               v-validate="'required'"
                               data-vv-as="link do produto"
                               v-model="itemSolicitacao.linkProduto">

                        <p class="text-danger" v-show="errors.has('link')">{{ errors.first('link') }}</p>
                    </div>
                </div>
            </div>

            <div v-if="itemSolicitacao.executora === '1'">
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group" :class="{'required': true, 'has-error': errors.has('projetoAceitarRetirarMercadoria')}">
                            <label class="control-label">O Projeto aceita retirar a(s) mercadoria(s) no endereço do CNPJ faturado (Av. Afrânio Peixoto, 14 - Butantã, São Paulo/SP - CEP 05507-000)?</label><br />

                            <radio v-model="itemSolicitacao.projetoAceitarRetirarMercadoria"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   :disabled="desabilitarExecutora"
                                   :class="[true ? '' : 'radioLeft']">
                                Sim
                            </radio>

                            <radio v-model="itemSolicitacao.projetoAceitarRetirarMercadoria"
                                   selected-value="false"
                                   type="success"
                                   :disabled="desabilitarExecutora"
                                   :inline="true">
                                Não
                            </radio>

                            <p class="text-danger" v-show="errors.has('link')">{{ errors.first('projetoAceitarRetirarMercadoria') }}</p>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="itemSolicitacao.projetoAceitarRetirarMercadoria == 'false'">
                    <div class="col-xs-12">
                        <div class="form-group" :class="{'required': true, 'has-error': errors.has('enderecoentreganovo')}">
                            <label class="control-label" for="enderecoentreganovo">Informe abaixo o endereço de entrega</label>

                            <textarea class="form-control"
                                      id="enderecoentreganovo"
                                      v-model="itemSolicitacao.observacaoItemCompra"
                                      data-vv-name="enderecoentreganovo"
                                      v-validate="'required'"
                                      data-vv-as="endereço de entrega"
                                      :disabled="desabilitarExecutora"
                                      maxlength="500">
                            </textarea>

                            <p class="text-danger" v-show="errors.has('enderecoentreganovo')">{{ errors.first('enderecoentreganovo') }}</p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group" :class="{'required': true , 'has-error': errors.has('projetoAceitarVariacaoPreco')}">
                            <label class="control-label">O Projeto aceita variação de preço no momento da compra?</label><br />

                            <radio v-model="itemSolicitacao.projetoAceitarVariacaoPreco"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   :disabled="desabilitarExecutora"
                                   :class="[true ? '' : 'radioLeft']">
                                Sim
                            </radio>

                            <radio v-model="itemSolicitacao.projetoAceitarVariacaoPreco"
                                   selected-value="false"
                                   type="success"
                                   :disabled="desabilitarExecutora"
                                   :inline="true">
                                Não
                            </radio>

                            <p class="text-danger" v-show="errors.has('link')">{{ errors.first('projetoAceitarVariacaoPreco') }}</p>
                        </div>
                    </div>

                    <div class="col-xs-2" v-if="itemSolicitacao.projetoAceitarVariacaoPreco == 'true'">
                        <div class="form-group required" :class="{'has-error': errors.has('percentualvariacaovalor')}">
                            <label class="control-label" for="percentualvariacaovalor">Percentual variação de preço</label>

                            <select id="percentualvariacaovalor"
                                    class="form-control"
                                    v-model="itemSolicitacao.percentualVariacaoValor"
                                    v-validate="'required'"
                                    data-vv-name="percentualvariacaovalor"
                                    data-vv-as="percentual variação preço"
                                    :disabled="desabilitarExecutora">

                                <option value="">Selecione...</option>
                                <option value="5">5%</option>
                                <option value="10">10%</option>
                            </select>

                            <p class="text-danger" v-show="errors.has('percentualvariacaovalor')">{{ errors.first('percentualvariacaovalor') }}</p>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group" :class="{'required': true , 'has-error': errors.has('projetoAceitarFrete')}">
                            <label class="control-label">O Projeto aceita pagar frete?</label><br />

                            <radio v-model="itemSolicitacao.projetoAceitarFrete"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   :disabled="desabilitarExecutora"
                                   :class="[true ? '' : 'radioLeft']">
                                Sim
                            </radio>

                            <radio v-model="itemSolicitacao.projetoAceitarFrete"
                                   selected-value="false"
                                   type="success"
                                   :disabled="desabilitarExecutora"
                                   :inline="true">
                                Não
                            </radio>

                            <p class="text-danger" v-show="errors.has('link')">{{ errors.first('projetoAceitarFrete') }}</p>
                        </div>
                    </div>

                    <div class="col-xs-2" v-if="itemSolicitacao.projetoAceitarFrete == 'true'">
                        <div class="form-group required" :class="{'has-error': errors.has('percentualvariacaofrete')}">
                            <label class="control-label" for="percentualvariacaofrete">Percentual variação do frete</label>

                            <select id="percentualvariacaofrete"
                                    class="form-control"
                                    v-model="itemSolicitacao.percentualVariacaoFrete"
                                    v-validate="'required'"
                                    data-vv-name="percentualvariacaofrete"
                                    data-vv-as="percentual variação frete"
                                    :disabled="desabilitarExecutora">

                                <option value="">Selecione...</option>
                                <option value="5">5%</option>
                                <option value="10">10%</option>
                            </select>

                            <p class="text-danger" v-show="errors.has('percentualvariacaofrete')">{{ errors.first('percentualvariacaofrete') }}</p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <label class="control-label">A FUSP será responsável por realizar a compra, inserir a solicitação de pagamento, acompanhar a entrega e informar o Projeto sobre a entrega ou retirada.</label>
                    </div>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>
            </div>

            <div v-if="itemSolicitacao.executora === '2'">
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                    <div class="col-xs-12">
                        <label class="control-label">
                            Por favor, leia o 'Termo de Responsabilidade e Sigilo' na aba que será disponibilizada após a inserção do primeiro item da solicitação.
                            Ao concordar com o termo, a FUSP fornecerá os dados de login e senha no momento da aprovação, através do sistema de mensagens desta plataforma.<br /><br />

                            <span style="text-decoration: underline;">Importante:</span><br />
                            A FUSP não realiza pagamentos via cartão de crédito ou PIX, apenas por boleto ou transferência bancária.
                            Caso o prazo para pagamento do boleto seja de apenas 1 (um) dia, recomendamos que a compra e a solicitação de pagamento seja feita às terças, quintas e sextas-feiras
                            até às 11:00.<br /><br />

                            Em caso de dúvidas acesse o manual desta solicitação
                        </label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                            <a href='https://www.fusp.org.br/files/doctos/compras_online_intrucoes_gerais.pdf' target="_blank">
                                <button type="button" class="btn btn-xs btn-primary">
                                    <i class="fa fa-file"></i>
                                    Instruções gerais
                                </button>
                            </a>
                    </div>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>
            </div>                      
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormComprasOnline.vue